import { environment } from "src/environments/environment";

export class Media{
    id!: string;
    filename!: string;
    name!: string;
    mimeType!: string;
    originalName!: string;
    path!: string;
    size!: number;
    baseUrlPath !: string;
    
    constructor(data: Partial<Media>){
        Object.assign(this, data);
        if(!data.baseUrlPath){
            this.baseUrlPath = `${environment.apiBaseUrl}/${data.path}`;
        }
    }
}